import React, {useEffect, useState} from "react";
import {
    Alert,
    createTheme,
    FormHelperText,
    Grid,
    InputAdornment,
    InputLabel,
    MenuItem,
    Select,
    Skeleton,
    Stack,
    TextField,
    Typography,
} from "@mui/material";
import {makeStyles} from "@mui/styles";

import {themeOptions} from "../../../theme";
import {ThemeProvider} from "@emotion/react";
import MainModal from "../../MainModal";
import ComponentHeader from "../../ComponentHeader";
import TeamTable from "../TeamTable";
import AccountBoxRoundedIcon from "@mui/icons-material/AccountBoxRounded";
import {useDispatch, useSelector} from "react-redux";
import {createTeam, deleteTeam, editTeam, getAllTeams} from "../../../redux/actions/team-action";
import CircularProgress from "@mui/material/CircularProgress";
import ApiEndpoints from "../../../utils/ApiEndpoints";
import {apiPut, fileUploadImage} from "../../../utils/apiRequests";
import {BASE_URL} from "../../../constant/apiURL";
import {getMinimalPlayers} from "../../../redux/actions/player-area-action/scores-action";
import {DropzoneArea} from "mui-file-dropzone";

const useStyles = makeStyles((theme) => ({
    outlineInputBorder: {
        "& * > fieldset > legend": {
            display: "none",
        },
        "& > fieldset > legend > span": {
            display: "none",
        },
        "& * > input": {
            padding: "10px !important",
        },
        "& * > select": {
            padding: "3.5px !important",
        },
    },
    addIconButton: {
        background: "#2C633C !important",
        height: "30px",
        width: "30px",
    },
    searchBtn: {
        backgroundColor: "#2C633C !important",
        paddingRight: "20px !important",
        paddingLeft: "20px !important",
        height: "40px",
    },
    bottomIconButton: {
        color: "white",
    },
    iconBtn: {
        backgroundColor: "#2C633C !important",
        padding: 0,
        borderRadius: "10px !important",
    },
    addIcon: {
        color: "white",
    },
    inputLabel: {
        fontWeight: "bold !important",
        top: "5px",
    },

    modalDescription: {
        borderTop: "1px solid #cdcdcd !important",
        padding: "15px",
        marginTop: "20px",
        borderBottom: "1px solid #cdcdcd !important",
    },
    logo: {
        maxWidth: "100px",
        maxHeight: "100px",
        objectFit: "contain",
    }
}));

const token = localStorage.getItem("token");

export default function TeamList(props) {
    const dispatch = useDispatch();
    const classes = useStyles();
    const theme = createTheme(themeOptions);
    const [createTeamPopup, setCreateTeamPopup] = useState(false);
    const [deleteTeamPopup, setDeleteTeamPopup] = useState(false);
    const [editTeamPopup, setEditTeamPopup] = useState(false);
    const [viewTeamPopup, setViewTeamPopup] = useState(false);
    const [selectedRows, setSelectedRows] = useState(null);

    const [name, setName] = useState("");
    const [description, setDescription] = useState("");
    const [playerIds, setPlayerIds] = useState([]);
    const [logo, setLogo] = useState("");

    const [clearRow, setClearRow] = useState(false);
    const [teamDetailData, setTeamDetailData] = useState();
    const [teamDataAlert, setTeamDataAlert] = useState(false);

    const [submit, setSubmit] = useState(false);
    const [editAlert, setEditAlert] = useState(false);
    const [editAlertMsg, setEditAlertMsg] = useState("");
    const listOfAllPlayersData = useSelector((state) => state?.getMinimalPlayerReducer?.data);
    const role = useSelector((state) => state?.userDetailsReducer?.role);
    let listOfAllPlayers = listOfAllPlayersData || [];

    const openModal = () => {
        setCreateTeamPopup(true);
        setName("");
        setPlayerIds([]);
        setDescription("");
        setLogo("");
    };
    const closeModal = () => {
        setCreateTeamPopup(false);
        setName("");
        setPlayerIds([]);
        setDescription("");
        setLogo("");
    };

    const onSelectRow = (e) => {
        setSelectedRows(e?.selectedRows[0]);
        setClearRow(false);
        setViewTeamPopup(true);
    };

    const teamData = useSelector((state) => state.teamReducer.data);
    const loadingState = useSelector((state) => state?.teamReducer);
    const loading = useSelector((state) => state?.teamReducer?.isLoading);

    let teams = teamData;
    const [searchText, setSearchText] = useState("");

    if (searchText) {
        teams = teamData?.filter((val) => {
            if (
                val?.name?.toLowerCase().includes(searchText.toLowerCase()) ||
                val?.address?.toLowerCase().includes(searchText.toLowerCase())
            ) {
                return val;
            }
        });
    }

    const onSubmit = async () => {
        let dataObj = {
            name: name,
            description: description,
            logo: logo,
            playerIds: playerIds,
        };
        const validate = async () => {
            const isEmpty = Object.keys(dataObj).some(function (x) {
                return dataObj[x] === "" || dataObj[x] === null;
            });
            if (isEmpty) {
                setSubmit(true);
                return false;
            } else {
                setSubmit(false);
                return true;
            }
        };
        const isValid = await validate();
        if (!isValid) return;
        dispatch(createTeam(dataObj));
        dispatch(getAllTeams());
        setCreateTeamPopup(false);
    };

    const onDeletePress = () => {
        setDeleteTeamPopup(true);
    };

    const onDelete = async () => {
        dispatch(deleteTeam(selectedRows?._id));
        dispatch(getAllTeams());
        setDeleteTeamPopup(false);
    };

    const onEdit = async () => {
        let dataObj = {
            name: name,
            description: description,
            logo: logo,
            playerIds: playerIds,
        };
        const validate = async () => {
            const isEmpty = Object.keys(dataObj).some(function (x) {
                return dataObj[x] === "" || dataObj[x] === null;
            });
            if (isEmpty) {
                setSubmit(true);
                return false;
            } else {
                setSubmit(false);
                return true;
            }
        };
        const isValid = await validate();
        if (!isValid) return;
        dispatch(editTeam(selectedRows?._id, dataObj));
        dispatch(getAllTeams());
        setSelectedRows(null);
        setEditTeamPopup(false);
    };

    const handleSwitchTeams = (id, value) => {
        const newsSwitchPayload = {
            status: value,
        };

        apiPut(
            `${ApiEndpoints.teams.base}${ApiEndpoints.teams.update}${id?._id}`,
            newsSwitchPayload,
            (res) => {
                setEditAlertMsg(res?.message);
                setEditAlert(true);

                setTimeout(() => {
                    setEditAlert(false);
                    setEditAlertMsg("");
                }, 1000);
            },
            (err) => {
                setTimeout(() => {
                    setEditAlert(false);
                    setEditAlertMsg("");
                }, 1000);
                setEditAlert(true);
                setEditAlertMsg({showAlert: true, msg: err?.message});
            }
        );
    };

    const _handleChangeFileImages = (val) => {
        if (val.length >= 0) {
            fileUploadImage(ApiEndpoints.teams.addImage, val[0])
                .then((res) => {
                    if (!res.error) {
                        setLogo(res?.logo)
                    }
                })
                .catch((err) => {
                    // console.log("err", err);
                });
        }
    };

    useEffect(() => {
        dispatch(getMinimalPlayers(role));
    }, [dispatch, role]);

    useEffect(() => {
        dispatch(getAllTeams());
    }, [dispatch])

    const file = new File([""], `${BASE_URL}${logo}`, {
        type: "text/plain",
    });

    const getPlayerFullName = (id) => {
        const player = listOfAllPlayers.find(player => player._id === id);
        return player.first_name + ' ' + player.last_name
    }

    return (
        <ThemeProvider theme={theme}>
            {/* { parent-container} */}
            <Grid container>
                <Grid item xs={12} p={3}>
                    {/* {container} */}
                    <Grid item container>
                        <Grid item xs={12}>
                            <ComponentHeader
                                headerTitle="Teams"
                                cbOpenModal={() => {
                                    openModal();
                                }}
                                onSearch={(e) => setSearchText(e)}
                            />
                        </Grid>
                    </Grid>
                    {/* {container} */}
                    <Grid item container>
                        <Grid item xs={12} mt={2}>
                            <Stack spacing={1}>
                                {editAlert ? (
                                    <Alert severity="success">{editAlertMsg}</Alert>
                                ) : (
                                    ""
                                )}
                            </Stack>
                        </Grid>
                    </Grid>
                    {/* {container} */}
                    <Grid item container>
                        {/* {container} */}
                        <Grid item xs={12} m={2}>
                            {loadingState?.loading === false ? (
                                <TeamTable
                                    clearRow={clearRow}
                                    progressPending={loading}
                                    progressComponent={<CircularProgress color="success"/>}
                                    data={teams || []}
                                    onSelectedRowsChange={onSelectRow}
                                    edit={editTeamPopup}
                                    selectedRow={selectedRows}
                                    onDeletePress={onDeletePress}
                                    setselectedrows={setSelectedRows}
                                    seteditVisible={setEditTeamPopup}
                                    editVisible={editTeamPopup}
                                    setName={setName}
                                    setDescription={setDescription}
                                    setPlayerIds={setPlayerIds}
                                    setLogo={setLogo}
                                    handleSwitchCourses={handleSwitchTeams}
                                    onRowClicked={e => {
                                        setName(e.name);
                                        setDescription(e.description);
                                        setPlayerIds([...e.players.map(player => player._id)]);
                                        setLogo(e.logo);
                                        setViewTeamPopup(true)
                                    }}
                                />
                            ) : (
                                <>
                                    <Skeleton/>
                                    <Skeleton animation="wave"/>
                                    <Skeleton animation="wave"/>
                                </>
                            )}
                        </Grid>
                    </Grid>

                    {/* {modal content} */}
                    <MainModal
                        show={createTeamPopup}
                        closeModal={() => setCreateTeamPopup(false)}
                        modalHeadTitle="Create Team"
                        btnLeftTitle="Back"
                        btnRightTitle="Save"
                        cb={() => {
                            closeModal();
                        }}
                        btnCloseModal={() => onSubmit()}
                        leftVariant="outlined"
                        rightVariant="contained"
                        sx={{display: "flex", alignSelf: "flex-end"}}
                        width="900px">
                        <Grid container>
                            <Grid item xs={12} mb={2}>
                                <Stack spacing={1}>
                                    <InputLabel shrink className={classes.inputLabel}>
                                        Name
                                    </InputLabel>
                                    <TextField
                                        onChange={e => setName(e.target.value)}
                                        value={name}
                                        required
                                        placeholder="Name"
                                        className={classes.outlineInputBorder}
                                        sx={{
                                            "& input": {
                                                marginLeft: "35px",
                                            },
                                        }}
                                        fullWidth
                                        variant="outlined"
                                        error={!name && submit}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment
                                                    sx={{
                                                        width: "50px",
                                                        height: "50px",
                                                        maxHeight: "48px",
                                                        backgroundColor: "#06623B",
                                                        position: "absolute",
                                                        top: "-5px",
                                                        left: " 0px",
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        alignItems: "center",
                                                        borderTopLeftRadius: "5px",
                                                        borderBottomLeftRadius: "5px",
                                                    }}>
                                                    <AccountBoxRoundedIcon
                                                        size="large"
                                                        style={{marginInlineStart: "-9px"}}
                                                        sx={{
                                                            fontSize: "30px",
                                                            color: "white",
                                                        }}
                                                    />
                                                </InputAdornment>
                                            ),
                                        }}
                                        helperText={!name && submit ? "Name is required" : ""}
                                    />
                                    <InputLabel shrink className={classes.inputLabel}>
                                        Description
                                    </InputLabel>

                                    <TextField
                                        onChange={e => setDescription(e.target.value)}
                                        value={description}
                                        required
                                        placeholder="Description"
                                        className={classes.outlineInputBorder}
                                        fullWidth
                                        variant="outlined"
                                        error={!description && submit}
                                        helperText={!description && submit ? "Description is required" : ""}
                                    />
                                    <InputLabel shrink className={classes.inputLabel}>
                                        Select Player
                                    </InputLabel>
                                    <Select
                                        multiple={true}
                                        variant="outlined"
                                        value={playerIds}
                                        onChange={e => setPlayerIds(e.target.value)}
                                        className={classes.outlineInputBorder}
                                        name="playerIds"
                                        label="."
                                        renderValue={(selected) =>
                                            selected.map(item => {
                                                const player = listOfAllPlayers.find(option => item === option?._id);
                                                return player?.first_name + ' ' + player?.last_name
                                            }).join(', ')
                                        }
                                    >
                                        {[...listOfAllPlayers].map((item, index) => (
                                            <MenuItem key={index} value={item._id}>
                                                <Grid container item>
                                                    <Grid item xs={10}>
                                                        {item.first_name + ' ' + item.last_name}
                                                    </Grid>
                                                </Grid>
                                            </MenuItem>
                                        ))}
                                    </Select>
                                    {playerIds.length === 0 && submit ?
                                        <FormHelperText error={true}>Player is
                                            required</FormHelperText> : null}

                                    <InputLabel shrink className={classes.inputLabel}>
                                        Logo
                                    </InputLabel>
                                    <DropzoneArea
                                        dropzoneText="Tap to upload"
                                        showPreviews={false}
                                        onChange={(e) => _handleChangeFileImages(e)}
                                        filesLimit={1}
                                        acceptedFiles={["image/*"]}
                                    />
                                    {!logo && submit ?
                                        <FormHelperText error={true}>Logo is required</FormHelperText> : null}

                                    {teamDataAlert && (
                                        <Alert variant="filled" severity="error">
                                            {teamDetailData?.message}
                                        </Alert>
                                    )}
                                </Stack>
                            </Grid>
                        </Grid>
                    </MainModal>

                    {/* DELETE MODAL */}
                    <MainModal
                        show={deleteTeamPopup}
                        closeModal={() => setDeleteTeamPopup(false)}
                        modalHeadTitle="Delete"
                        btnLeftTitle="Ok"
                        btnRightTitle="Cancel"
                        btnCloseModal={() => setDeleteTeamPopup(false)}
                        leftVariant="outlined"
                        rightVariant="contained"
                        sx={{display: "none"}}
                        width="500px"
                        cb={onDelete}>
                        <Grid item container>
                            <Grid item xs={12} mb={2}>
                                <Stack spacing={1}>
                                    <div className={classes.modalDescription}>
                                        <p> Are you sure, you want to Delete?</p>
                                    </div>
                                </Stack>
                            </Grid>
                        </Grid>
                    </MainModal>

                    {/* EDIT MODAL */}
                    <MainModal
                        show={editTeamPopup}
                        closeModal={() => setEditTeamPopup(false)}
                        modalHeadTitle="Edit Team"
                        btnLeftTitle="Save"
                        btnRightTitle="Cancel"
                        btnCloseModal={() => setEditTeamPopup(false)}
                        leftVariant="contained"
                        rightVariant="outlined"
                        sx={{display: "none"}}
                        width="900px"
                        cb={onEdit}>
                        <Grid container>
                            <Grid item xs={12} mb={2}>
                                <Stack spacing={1}>
                                    <InputLabel shrink className={classes.inputLabel}>
                                        Name
                                    </InputLabel>
                                    <TextField
                                        onChange={e => setName(e.target.value)}
                                        value={name}
                                        required
                                        placeholder="Name"
                                        className={classes.outlineInputBorder}
                                        sx={{
                                            "& input": {
                                                marginLeft: "35px",
                                            },
                                        }}
                                        fullWidth
                                        variant="outlined"
                                        error={!name && submit}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment
                                                    sx={{
                                                        width: "50px",
                                                        height: "50px",
                                                        maxHeight: "48px",
                                                        backgroundColor: "#06623B",
                                                        position: "absolute",
                                                        top: "-5px",
                                                        left: " 0px",
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        alignItems: "center",
                                                        borderTopLeftRadius: "5px",
                                                        borderBottomLeftRadius: "5px",
                                                    }}>
                                                    <AccountBoxRoundedIcon
                                                        size="large"
                                                        style={{marginInlineStart: "-9px"}}
                                                        sx={{
                                                            fontSize: "30px",
                                                            color: "white",
                                                        }}
                                                    />
                                                </InputAdornment>
                                            ),
                                        }}
                                        helperText={!name && submit ? "Name is required" : ""}
                                    />
                                    <InputLabel shrink className={classes.inputLabel}>
                                        Description
                                    </InputLabel>

                                    <TextField
                                        onChange={e => setDescription(e.target.value)}
                                        value={description}
                                        required
                                        placeholder="Description"
                                        className={classes.outlineInputBorder}
                                        fullWidth
                                        variant="outlined"
                                        error={!description && submit}
                                        helperText={!description && submit ? "Description is required" : ""}
                                    />
                                    <InputLabel shrink className={classes.inputLabel}>
                                        Select Player
                                    </InputLabel>
                                    <Select
                                        multiple={true}
                                        variant="outlined"
                                        value={playerIds}
                                        onChange={e => setPlayerIds(e.target.value)}
                                        className={classes.outlineInputBorder}
                                        name="playerIds"
                                        label="."
                                        renderValue={(selected) =>
                                            selected.map(item => {
                                                const player = listOfAllPlayers.find(option => item === option?._id);
                                                return player?.first_name + ' ' + player?.last_name
                                            }).join(', ')
                                        }
                                    >
                                        {[...listOfAllPlayers].map((item, index) => (
                                            <MenuItem key={index} value={item._id}>
                                                <Grid container item>
                                                    <Grid item xs={10}>
                                                        {item.first_name + ' ' + item.last_name}
                                                    </Grid>
                                                </Grid>
                                            </MenuItem>
                                        ))}
                                    </Select>
                                    {playerIds.length === 0 && submit ?
                                        <FormHelperText error={true}>Player is
                                            required</FormHelperText> : null}

                                    <InputLabel shrink className={classes.inputLabel}>
                                        Logo
                                    </InputLabel>
                                    <DropzoneArea
                                        dropzoneText="Tap to upload"
                                        initialFiles={[file !== undefined ? file.name : null]}
                                        showPreviews={false}
                                        onChange={(e) => _handleChangeFileImages(e)}
                                        filesLimit={1}
                                        acceptedFiles={["image/*"]}
                                    />
                                    {!logo && submit ?
                                        <FormHelperText error={true}>Logo is required</FormHelperText> : null}

                                    {teamDataAlert && (
                                        <Alert variant="filled" severity="error">
                                            {teamDetailData?.message}
                                        </Alert>
                                    )}
                                </Stack>
                            </Grid>
                        </Grid>
                    </MainModal>

                    {/* View MODAL */}
                    <MainModal
                        show={viewTeamPopup}
                        closeModal={() => setViewTeamPopup(false)}
                        modalHeadTitle="View Team"
                        btnLeftTitle=""
                        btnRightTitle="Cancel"
                        btnCloseModal={() => setViewTeamPopup(false)}
                        leftVariant="contained"
                        rightVariant="outlined"
                        sx={{display: "none"}}
                        width="900px">
                        <Grid container>
                            <Grid container borderBottom={"1px solid rgba(0, 0, 0, 0.1)"} className={'pb-3'}>
                                <Grid item md={12} className={'text-center'}>
                                    <img src={BASE_URL + logo} alt={'Logo'} className={classes.logo}/>
                                </Grid>
                            </Grid>
                            <Grid container borderBottom={"1px solid rgba(0, 0, 0, 0.1)"} className={'py-3'}>
                                <Grid item md={6} xs={12}>
                                    <Typography fontWeight={700}>Name</Typography>
                                </Grid>
                                <Grid item md={6} xs={12}>
                                    <Typography>{name}</Typography>
                                </Grid>
                            </Grid>
                            <Grid container borderBottom={"1px solid rgba(0, 0, 0, 0.1)"} className={'py-3'}>
                                <Grid item md={6} xs={12}>
                                    <Typography fontWeight={700}>Description</Typography>
                                </Grid>
                                <Grid item md={6} xs={12}>
                                    <Typography>{description}</Typography>
                                </Grid>
                            </Grid>
                            <Grid container className={'pt-3'}>
                                <Grid item md={6} xs={12}>
                                    <Typography fontWeight={700}>Players</Typography>
                                </Grid>
                                <Grid container>
                                    {
                                        playerIds.map(id =>
                                            <Grid item md={4} xs={12} borderBottom={"1px solid rgba(0, 0, 0, 0.1)"}
                                                  className={'py-2 mb-2'}>
                                                <Typography>{getPlayerFullName(id)}</Typography>
                                            </Grid>
                                        )
                                    }
                                </Grid>
                            </Grid>
                        </Grid>
                    </MainModal>
                </Grid>
            </Grid>
        </ThemeProvider>
    );
}
